import React from 'react';
import PropTypes from 'prop-types';
import lodashGet from 'lodash/get';
import cx from 'classnames';
import i18n from '../../utils/i18n';
import {attachmentAttributesType} from '../../constants/proptype-validation/attachment-proptypes';
import {shortRelativeDateString} from '../../utils/date-helpers';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import OverflowTooltip from '@adsk/bim360-matrix-react-overflow-tooltip';

const IssueAttachmentDescription = ({userNameDisplayNameWithCompany, attachment, container}) => {
  if (lodashGet(attachment, 'progress')) {
    return (
      <div
        className={cx('IssueAttachmentDescription', {
          'IssueAttachmentDescription--failed': attachment.isFailed
        })}
      >
        {attachment.isFailed ? i18n.t('attachments.UploadFailed') : i18n.t('attachments.uploading')}
      </div>
    );
  }
  return (
    <div className="IssueAttachmentDescription">
      <span className="IssueAttachmentDescription__created-by">
        <OverflowTooltip autoTipOnEllipsis place={Tooltip.Places.BOTTOMKs} container={container}>
          {userNameDisplayNameWithCompany}
        </OverflowTooltip>
      </span>
      <span className="IssueAttachmentDescription__circle" />
      <span className="IssueAttachmentDescription__created-date">{shortRelativeDateString(attachment.createdAt)}</span>
    </div>
  );
};

IssueAttachmentDescription.displayName = 'IssueAttachmentDescription';

IssueAttachmentDescription.propTypes = {
  attachment: attachmentAttributesType.isRequired,
  userNameDisplayNameWithCompany: PropTypes.string,
  container: PropTypes.objects
};

export default IssueAttachmentDescription;
